import PropTypes from 'prop-types';
// material-ui
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

// project imports
import useConfig from 'hooks/useConfig';
import { ThemeMode } from 'config';

// assets
import logoLong from 'assets/images/logo-light-long.png';
import logoShort from 'assets/images/logo-light-short.png';

// ==============================|| LOGO MAIN ||============================== //

export default function LogoMain({ reverse }) {
  const theme = useTheme();
  const { mode } = useConfig();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isDarkMode = mode === ThemeMode.DARK;

  return (
    <Box
      component="img"
      src={isMobile ? logoShort : logoLong}
      alt="AYRO Logo"
      sx={{
        height: 40,
        width: 'auto',
        objectFit: 'contain',
        // In dark mode, apply filter to make logo whitish for better visibility
        filter: isDarkMode ? 'brightness(0) invert(1) brightness(0.9)' : 'none'
      }}
    />
  );
}

LogoMain.propTypes = { reverse: PropTypes.bool };
